<template>
  <v-autocomplete
    v-model="selection"
    :id="elementId"
    :label="label"
    :multiple="multiple"
    :chips="multiple"
    :deletable-chips="multiple"
    :clearable="true"
    :items="speciesList"
    :disabled="!(speciesList?.length > 0)"
    :prepend-icon="IconHelpers.getIconForObjectType('species')"
    item-value="speciesEnum"
    item-text="commonName"
    return-object
    :persistent-hint="!!hint"
    :hint="hint ? hint : undefined"
    @change="speciesChosen"
    :error-messages="errorMessages"
  >
    <template #selection="{ item }">
      <v-chip
        v-if="item && multiple"
        class="my-1 mr-1"
        close
        @click:close="chipClosed(item)"
      >
        <span>{{ item.commonName }}</span>
      </v-chip>
      <span
        v-else
        :style="selectorSelectionTextStyle"
      >{{ item.commonName }}</span>
    </template>

    <template #item="{ item }">
      <v-list-item-content @click="handleItemClick(item, $event)">
        <v-list-item-title>
          <v-row>
            <v-col cols="auto" v-if="multiple">
              <v-icon>
                {{ getCheckboxIcon(item) }}
              </v-icon>
            </v-col>

            <v-col>
              <span>{{ item.commonName }}</span>
            </v-col>

            <v-col cols="auto">
              <Icon
                icon="mdi-information-outline"
                iconColor="info"
                :small="false"
                :tooltipText="item.speciesName"
                tooltipClass="font-italic"
              >
              </Icon>
            </v-col>
          </v-row>
        </v-list-item-title>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import IconHelpers from '@/utils/IconHelpers'
import { selectorSelectionTextStyle } from '@/utils/componentHelpers'
import { shiftSelectClick } from '@/utils/shiftSelect'

export default {
  name: 'SpeciesAutocomplete',

  components: {
    Icon: () => import('@/components/helper/Icon.vue')
  },

  props: {
    elementId: {
      type: String,
      required: false,
      default: 'species-autocomplete'
    },
    speciesList: {
      type: Array,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    initSelection: {
      type: [Array, Object],
      required: false,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      required: false,
      default: undefined
    },
    errorMessages: {
      type: [Array, String],
      required: false,
      default: undefined
    }
  },

  data: () => ({
    IconHelpers,
    selectorSelectionTextStyle,
    selection: null,
    lastSelectedIndex: null
  }),

  computed: {
    label () {
      return this.$t('species')
    }
  },

  created () {
    if (this.initSelection) {
      this.selection = this.initSelection
    } else if (this.multiple) {
      this.selection = []
    } else {
      this.selection = null
    }
  },

  methods: {
    handleItemClick (item, event) {
      if (!this.multiple) return
      const { selection, anchor } = shiftSelectClick(
        this.speciesList, this.selection, this.lastSelectedIndex, item, event
      )
      this.lastSelectedIndex = anchor
      if (selection !== null) {
        this.selection = selection
        this.$emit('species-chosen', this.selection)
      }
    },

    speciesChosen (value) {
      this.$emit('species-chosen', value)
    },

    chipClosed (item) {
      this.selection = this.selection.filter((i) => i.speciesEnum !== item.speciesEnum)
      this.$emit('species-chosen', this.selection)
    },

    getCheckboxIcon (item) {
      if (this.multiple) {
        return this.selection.some(i => i.speciesEnum === item.speciesEnum) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'
      } else {
        return item === this.selection ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'
      }
    }
  }
}
</script>
